<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn depressed
              color="primary"
              class="float-right users"
              v-on="on"
      >
        <v-badge
          color="primary"
          overlap
          class="float-right users"
        >
          <template v-slot:badge>
            <span>{{newMessagesCount}}</span>
          </template>
          <v-icon color="grey">mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          Last Alerts
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list style="max-height: 400px; overflow-y: auto;" dense>
        <span
          v-for="item_alert in alert_list"
          :key="item_alert.id"
          @click="onClickAlert(item_alert)"
          :style="item_alert.status == STATUS_NEW ? 'cursor: pointer;' : ''"
        >
          <v-list-item v-if="item_alert.channel == 'timesheet_channel' && item_alert.event == 'request'">
            <v-list-item-action>
              <v-icon style="font-size: 18px;" :color="getIconColorRequest(item_alert)">mdi-car-info</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{mysqlTimestampToDate(item_alert.created_at)}}, {{getMessage(item_alert)}}</v-list-item-title>
          </v-list-item>
          <v-list-item v-else-if="item_alert.channel == 'timesheet_channel' && item_alert.event == 'reject'">
            <v-list-item-action>
              <v-icon style="font-size: 18px;" :color="getIconColorReject(item_alert)">mdi-car-off</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{mysqlTimestampToDate(item_alert.created_at)}}, {{getMessage(item_alert)}}</v-list-item-title>
          </v-list-item>
          <v-list-item v-else-if="item_alert.channel == 'news_feed_channel' && item_alert.event == 'publish'">
            <v-list-item-action>
              <v-icon style="font-size: 18px;" :color="getIconColorPublish(item_alert)">mdi-message-alert</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              {{mysqlTimestampToDate(item_alert.created_at)}}, {{getMessage(item_alert)}}
              </v-list-item-title>
          </v-list-item>

          <v-list-item v-else>
            <v-list-item-action>
                <v-icon style="font-size: 18px;" :color="getIconColor(item_alert)">mdi-bell-outline</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{mysqlTimestampToDate(item_alert.created_at)}}, {{getMessage(item_alert)}}</v-list-item-title>
          </v-list-item>
        </span>
        
        <v-list-item v-if="alert_list.length == 0">
          <v-list-item-action>
              <!-- <v-icon>mdi-bell-outline</v-icon> -->
            </v-list-item-action>
            <v-list-item-title><i>No alerts</i></v-list-item-title>
        </v-list-item>

      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="menu = false">Cancel</v-btn>
        <v-btn color="primary" text @click="markAllReaded()" :loading="markAllLoading">Mark all Read</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import { STATUS_NEW, STATUS_READ } from '../../store/alerts'
import moment from 'moment';
import _ from 'lodash';

const ROLE_ADMIN = 10;
const ROLE_MANAGER = 20;

export default {
    props: [],
    name: "AlertsDropdownMenu",

    data: () => ({
      menu: false,
      alerts: [],
      markAllLoading: false,
      STATUS_NEW: STATUS_NEW,
      STATUS_READ: STATUS_READ,
    }),
    created() {
      // --
      let user = JSON.parse(localStorage.getItem("user"));
      this.$store.commit('setUser',user);
      if (user && (parseInt(user.role) == ROLE_ADMIN || parseInt(user.role) == ROLE_MANAGER)) {
        this.$store.dispatch('fetchAlerts');
      }
    },

    computed: {
      ...mapGetters({
        alert_list: 'alerts',
        driver_list: 'drivers',
      }),
      newMessagesCount() {
        if (_.isEmpty(this.alert_list)) {
          return 0;
        }

        return _.sumBy(this.alert_list, p => Number(p.status == STATUS_NEW));
      }
    },

    methods: {
      // --
      getIconColorRequest(item) {
        if (item.status == STATUS_NEW) {
          return 'green';
        }
        return 'greay';
      },
      getIconColorReject(item) {
        if (item.status == STATUS_NEW) {
          return 'red';
        }
        return 'greay';
      },
      getIconColorPublish(item) {
        if (item.status == STATUS_NEW) {
          return 'blue';
        }
        return 'greay';
      },
      getIconColor(item) {
        if (item.status == STATUS_NEW) {
          return 'green';
        }
        return 'greay';
      },
      getMessage(item_alert) {
        let data = JSON.parse(item_alert.data);
        return data.message;
      },
      markAllReaded() {
        this.markAllLoading = true;
        this.$store.dispatch('allReadedAlerts').then(() => {
          this.markAllLoading = false;
          this.menu = false;
        });
      },
      onClickAlert(item_alert) {
        let data = {
          id: item_alert.id,
          status: STATUS_READ,
        };

        // markReaded
        this.markAllLoading = true;
        this.$store.dispatch('editAlert', data).then(() => {
          this.markAllLoading = false;
        });
      },
      mysqlTimestampToDate(created_at) {
        return moment.utc(created_at, 'YYYY-MM-DD HH:mm:ss').local().format('DD/MM/YYYY HH:mm')
      }
    },
}
</script>

<style scoped>

</style>
